import { ethers } from 'ethers'
import { WALLET_ADDRESS_LENGTH, WALLET_ADDRESS_PREFIX } from '../assets/constants'

const isServerSide = typeof window === 'undefined'
declare global {
  interface Window {
    ethereum: any
  }
}
export const MetamaskService = {
  isValidAddress: (target: string): boolean =>
    target.length === WALLET_ADDRESS_LENGTH && target.startsWith(WALLET_ADDRESS_PREFIX),
  requestConnectionToMetamsk: async (): Promise<boolean> => {
    const provider = new ethers.providers.Web3Provider(window.ethereum)
    return await provider
      .send('eth_requestAccounts', [])
      .then(() => true)
      .catch(() => false)
  },
  switchToSupportedChain: () => {
    window.ethereum.request?.({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: process.env.NEXT_PUBLIC_CHAIN_ID }],
    })
  },
  getCurrentChainId: () =>
    MetamaskService.getSigner()
      .getChainId()
      .catch(() => undefined),
  getWalletAddress: () =>
    MetamaskService.getSigner()
      .getAddress()
      .catch((error) => {
        console.error(error)
        return undefined
      }),
  getProvider: () => new ethers.providers.Web3Provider(window?.ethereum),
  isInstalledMetamask: () => (isServerSide ? false : !!window?.ethereum),
  getSigner: () => MetamaskService.getProvider().getSigner(),
  signMessage: (message: string) => MetamaskService.getSigner().signMessage(message),
}
